export const salesEditMode = Object.freeze({
  documentUpload: 'DOCUMENT_UPLOAD',
  salesSummary: 'SALES_SUMMARY',
})
